var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.42,
    height: 23,
    viewBox: "0 0 82.42 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_71",
    "data-name": "Union 71",
    d: "M8.42,23a5,5,0,0,1-5-5V14.519a2.03,2.03,0,0,1-.48-.2L1.02,13.244a2,2,0,0,1,0-3.487L2.94,8.677a2.033,2.033,0,0,1,.48-.2V5a5,5,0,0,1,5-5h69a5,5,0,0,1,5,5V18a5,5,0,0,1-5,5Z",
    transform: "translate(0)",
    fill: "#00b248",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgBox);
export default __webpack_public_path__ + "static/media/msgBox.804469eee8ab3a839e0671c78a2cbda4.svg";
export { ForwardRef as ReactComponent };